export const FIND_RIDE_ANY_TIME = "00:01:01";
export const FIND_RIDE_CONTEXT = "findride";
export const PENDING_FIND_RIDE_SEARCH_KEY = "pendingFindRideSearch";

export const FIND_RIDE_MIN_SEATS = 1;
export const FIND_RIDE_MAX_SEATS = 8;
export const FIND_RIDE_COUNTRY_CODE = "IN";

/** Paths relative to OFFER_API_BASE. */
export const FIND_RIDE_API_PATHS = {
  search: "/rides",
  laterRides: "/laterrides",
} as const;

/** Design tokens aligned to Find Ride marketing screen. */
export const FIND_RIDE_COLORS = {
  /** Deep forest green — titles, CTA, active chips */
  pageGreen: "#1A5336",
  ctaGreen: "#1A5336",
  /** Highlight in hero subtitle */
  accentGreen: "#3D8B5F",
  pinGreen: "#22C55E",
  pinAmber: "#F59E0B",
  accentGold: "#C9A227",
  refreshGreen: "#22C55E",
  textPrimary: "#1F2937",
  textSecondary: "#6B7280",
  labelGray: "#9CA3AF",
} as const;
